import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=1bb6c98d&scoped=true&"
import script from "./Chat.vue?vue&type=script&lang=js&"
export * from "./Chat.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Chat.vue?vue&type=style&index=0&id=1bb6c98d&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1bb6c98d",
  null
  ,true
)

export default component.exports